import { useEffect, useState } from 'react';
import { Connector } from '../models/Station';
import { ReactComponent as ConnectorIconJ1772 } from '../assets/j1772plug.svg';

interface ConnectorSelectorProps {
    connectors: Connector[];
    showFull?: boolean;
    onPress: (selection: number) => void;
}

const ConnectorSelector: React.FC<ConnectorSelectorProps> = ({
    connectors,
    showFull = false,
    onPress,
}) => {
    const [selectedConnector, setSelectedConnector] = useState<number | null>(
        null
    );

    const handleSelect = (connector: number) => {
        setSelectedConnector(connector);
        onPress(connector);
    };

    const isAvailable = (status: string) => {
        return (
            status === 'AVAILABLE' ||
            status === 'PREPARING' ||
            status === 'FINISHING'
        );
    };

    return (
        <div className="connector-selector-container">
            {!showFull && (
                <div className="connector-selector-title">SELECT PLUG</div>
            )}
            <div className="connector-selector">
                {connectors.map((connector) => {
                    return (
                        <div
                            key={connector.id}
                            onClick={() =>
                                isAvailable(connector.status)
                                    ? handleSelect(connector.connector)
                                    : null
                            }
                            className={
                                'connector-selector-item-container ' +
                                (isAvailable(connector.status)
                                    ? 'available'
                                    : 'unavailable')
                            }
                        >
                            {showFull && (
                                <ConnectorIconJ1772 className="connector-selector-item-icon" />
                            )}
                            <div
                                className={
                                    selectedConnector === connector.connector
                                        ? 'connector-selector-item selected'
                                        : 'connector-selector-item'
                                }
                                key={connector.id}
                            >
                                <div className="connector-selector-item-title">
                                    Plug {connector.connector}
                                </div>
                                <div className="connector-selector-item-name">
                                    {connector.connectorType}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ConnectorSelector;
